<template>
  <div>
      <w-loading-spinner :loadSpinner="loading" />
  <b-modal
            v-model="openWorkflowHistoryModal"
            ok-title="ok"
            :title="'Workflow of document - '+ docSearch"
            @ok="closeTrackingModal($event)"
            @cancel="eventCancel($event)"
            scrollable
            :no-close-on-esc="true"
            :ok-only="true"
            modal-class="modal-fullscreen" >
            <div class="table table-responsive">        
<table class="table-striped wf-history-table">
  <thead><tr>
    <!--th>Document No</th-->
    <th>Receiver</th>
    <th>Receiver Email</th>
    <th>Sender</th>
    <th>Sender Email</th>
    <th>Action Status</th>
    <th>Remarks</th>
    <th>Inserted On</th>
    <th>Updated On</th>
    <!--th>Version Number</th>
    <th>Company Code</th>
    <th>Doc WF Id</th-->
    </tr></thead>
  <tbody> 
    <tr v-for="(i,index) in historyList" :key="index" v-show="i.actionStatus != 6">
    <!--td>{{docSearch}}</td--> 
    <td>{{i.remarks && i.remarks.split('-receiverdelimiter-').length > 1 && i.remarks.split('-receiverdelimiter-')[1].split('-senderdelimiter-')[0].split('~~~')[1].split('^^^')[0]}}</td>
    <td>{{i.remarks && i.remarks.split('-receiverdelimiter-').length > 1 &&  i.remarks.split('-receiverdelimiter-')[1].split('-senderdelimiter-')[0].split('~~~')[1].split('^^^')[1]}}</td>
    <td>{{i.remarks && i.remarks.split('-senderdelimiter-').length > 1 && i.remarks.split('-senderdelimiter-')[1].split('~~~')[1].split('^^^')[0]}}</td>
    <td>{{i.remarks && i.remarks.split('-senderdelimiter-').length > 1 && i.remarks.split('-senderdelimiter-')[1].split('~~~')[1].split('^^^')[1]}}</td>
    <td>{{i.actionStatus == 1 ? 'Approved' : ''}}
      {{i.actionStatus == 2 ? 'SendBack' : ''}}
      {{i.actionStatus == 3 ? 'Rejected' : ''}}
      {{i.actionStatus == 4 ? 'Requested' : ''}}
      {{i.actionStatus == 5 ? 'PartialApproved' : ''}}
      {{i.actionStatus == 6 ? 'AutoCancel' : ''}}
      {{i.actionStatus == 7 ? 'Created' : ''}}
      {{i.actionStatus == 8 ? 'Resolved' : ''}}
      {{i.actionStatus == 9 ? 'Closed' : ''}}
      {{i.actionStatus == 10 ? 'Forwarded' : ''}}
      {{i.actionStatus == 11 ? 'Reopened' : ''}}
      {{i.actionStatus == 13 ? 'Reviewed' : ''}}</td>
    <td>{{i.remarks && i.remarks.split('-receiverdelimiter-').length > 0 && i.remarks.split('-receiverdelimiter-')[0]}}</td>
    <td>{{formatDateTime(i.insertedOn, 'T')}}</td>
    <td>{{formatDateTime(i.updatedOn, 'T')}}</td>
    <!--td>{{i.versionNumber}}</td>
    <td>{{i.companyCode}}</td>
    <td>{{i.documentWorkflowId}}</td-->
    </tr>
    </tbody>
</table>
  </div>
  </b-modal>
    <b-modal
            v-model="openTrackingModal"
            ok-title="ok"
            :title="'TrackingStatus - '+currentDocuNumberForAction"
            @ok="closeTrackingModal($event)"
            @cancel="eventCancel($event)"
            scrollable
            :no-close-on-esc="true"
            :ok-only="true"
            size="xl"
            modal-class="modal-fullscreen"
          >
                        
<table class="table-striped wf-history-table">
  <tbody>
    <tr v-for="(i,index) in traceData" :key="index">
      <td v-if="index==0 && originalArray.length > 0" class="trace-wrap">
        <div :title="originalArray[0].remarks && originalArray[0].remarks.split('-senderdelimiter-')[1].split('~~~')[1].split('^^^')[0]">
          <span class="bold">By:</span> 
    {{originalArray[0].remarks && originalArray[0].remarks.split('-senderdelimiter-')[1].split('~~~')[1].split('^^^')[0]}}</div>
   
    <div :title="Partner"><span class="bold">Role:</span> Partner</div>
    <div><span class="bold">Action:</span>
    <span class="text-green"> Submitted</span></div>
    <div :title="originalArray[0].remarks && originalArray[0].remarks.split('-receiverdelimiter-')[0]"><span class="bold">Remarks:</span> {{originalArray[0].remarks && originalArray[0].remarks.split('-receiverdelimiter-')[0]}}</div>
    <!--div>{{j.insertedOn.replace('T',' ').split('.')[0]}}</div-->
    <div :title="formatDateTime(originalArray[0].updatedOn,'T')"><span class="bold">updated:</span>
     {{formatDateTime(originalArray[0].updatedOn,'T')}}</div>
    <!--td>{{i.versionNumber}}</td>
    <td>{{i.companyCode}}</td>
    <td>{{i.documentWorkflowId}}</td-->

        </td>
      <td v-for="(j,k) in i" :key="k" class="trace-wrap" v-if="j.isShow || j.actionStatus != 4 || ((j.frCode==0 || j.frCode ==101) && j.actionStatus==4)">
    <div v-if="!(index==0 && k==0)" :title="j.remarks && j.remarks.split('-receiverdelimiter-').length > 1 && j.remarks.split('-receiverdelimiter-')[1].split('-senderdelimiter-')[0].split('~~~')[1].split('^^^')[0]">
        <span class="bold">Actor:</span>
        {{j.remarks && j.remarks.split('-receiverdelimiter-').length > 1 && j.remarks.split('-receiverdelimiter-')[1].split('-senderdelimiter-')[0].split('~~~')[1].split('^^^')[0]}}
    </div>
    <div v-if="index==0 && k==0" :title="j.remarks && j.remarks.split('-senderdelimiter-').length > 1 && j.remarks.split('-senderdelimiter-')[1].split('~~~')[1].split('^^^')[0]">
        <span class="bold">Actor:</span>
        {{j.remarks && j.remarks.split('-senderdelimiter-').length > 1 && j.remarks.split('-senderdelimiter-')[1].split('~~~')[1].split('^^^')[0]}}
    </div>
    <div :title="getRoleName(j.frCode)"><span class="bold">Role: </span> {{getRoleName(j.frCode)}}</div>
    <div>
        <span class="bold">Action:</span>
        <span v-if="(j.frCode ==0 || getRoleName(j.frCode) == 'Partner')" class="text-green"> Submitted</span>
        <span
            v-if="!(j.frCode ==0 || getRoleName(j.frCode) == 'Partner')"
            :class="[j.actionStatus == 1 ? 'text-green':'', j.actionStatus == 2 ? 'text-orange':'',
         j.actionStatus == 3 ? 'text-red':'',j.actionStatus == 4 ? 'text-yellow':'']"
        >
            {{j.actionStatus == 1 ? 'Approved' : ''}} {{j.actionStatus == 2 ? 'SendBack' : ''}} {{j.actionStatus == 3 ? 'Rejected' : ''}} {{j.actionStatus == 4 ? 'Requested' : ''}} {{j.actionStatus == 5 ? 'PartialApproved' : ''}}
            {{j.actionStatus == 6 ? 'AutoCancel' : ''}} {{j.actionStatus == 7 ? 'Created' : ''}} {{j.actionStatus == 13 ? 'Reviewed' : ''}}
        </span>
    </div>
    <div :title="j.remarks && j.remarks.split('-receiverdelimiter-').length > 0 && j.remarks.split('-receiverdelimiter-')[0]"><span class="bold">Remarks:</span> {{j.remarks && j.remarks.split('-receiverdelimiter-')[0]}}</div>
    <!--div>{{j.insertedOn.replace('T',' ').split('.')[0]}}</div-->
    <div :title="formatDateTime(j.updatedOn,'T')"><span class="bold">updated On:</span> {{formatDateTime(j.updatedOn,'T')}}</div>
    <!--td>{{i.versionNumber}}</td>
      <td>{{i.companyCode}}</td>
      <td>{{i.documentWorkflowId}}</td-->
</td>

    </tr>
    </tbody>
</table>    
            <!-- <span > old tracking --> 
            <!--div class="row m-0 p-3" v-for="(data,index) in trackingData" :key="index">
              <div class="col-2 m-0 p-0 pl-3">
                <h4
                  v-if="index == 0"
                  id="tooltip-target-1"
                  class="role-Name mb-2 m-0 p-0"
                >{{roleName[0]}}</h4>
                <span v-if="data.partner != null">
                  <span :class="dottedStatus(data.partner.evaluatorsActionStatus)"></span>
                  <span class="popOverStatus ml-2">{{data.partner.evaluatorsActionStatus}}</span>
                  <br />
                  <span class="popOverDate">{{getCreatedDate(data.partner.insertedOn)}}</span>
                </span>
                <span class="popOverStatus ml-2" v-else>
                  <span>-</span>
                </span>
              </div>
              <div class="col-2 m-0 p-0 pl-3">
                <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[1]}}</h4>
                <span v-if="data.segregator != null">
                  <span :class="dottedStatus(data.segregator.evaluatorsActionStatus)"></span>
                  <span class="popOverStatus ml-2">{{data.segregator.evaluatorsActionStatus}}</span>
                  <br />
                  <span class="popOverStatusActionBy">{{data.segregator.actionBy}}</span>
                  <br />
                  <span class="popOverDate">{{getCreatedDate(data.segregator.insertedOn)}}</span>
                  <br />
                  <button
                    class="popOverRemarks"
                    v-b-popover.hover.bottomright="data.segregator.remarks"
                  >Remarks</button>
                </span>
                <span class="popOverStatus ml-2" v-else>
                  <span>-</span>
                </span>
              </div>
              <div class="col-2 m-0 p-0 pl-3">
                <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[2]}}</h4>
                <span v-if="data.buyer != null">
                  <span :class="dottedStatus(data.buyer.evaluatorsActionStatus)"></span>

                  <span class="popOverStatus ml-2">{{data.buyer.evaluatorsActionStatus}}</span>
                  <br />
                  <span class="popOverStatusActionBy">{{data.buyer.actionBy}}</span>
                  <br />
                  <span class="popOverDate">{{getCreatedDate(data.buyer.insertedOn)}}</span>
                  <br />
                  <button
                    class="popOverRemarks"
                    v-b-popover.hover.bottomright="data.buyer.remarks"
                  >Remarks</button>
                </span>
                <span class="popOverStatus ml-2" v-else>
                  <span v-if="trackingData.length-1 == index">
                    <span :class="dottedStatus('Pending')"></span>
                    <span class="ml-2">Pending</span>
                  </span>
                  <span v-else>-</span>
                </span>
              </div>
              <div class="col-2 m-0 p-0 pl-3">
                <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[3]}}</h4>
                <span v-if="data.technical != null">
                  <span :class="dottedStatus(data.technical.evaluatorsActionStatus)"></span>
                  <span class="popOverStatus ml-2">{{data.technical.evaluatorsActionStatus}}</span>
                  <br />
                  <span class="popOverStatusActionBy">{{data.technical.actionBy}}</span>
                  <br />
                  <span class="popOverDate">{{getCreatedDate(data.technical.insertedOn)}}</span>
                  <br />
                  <button
                    class="popOverRemarks"
                    v-b-popover.hover.bottomright="data.technical.remarks"
                  >Remarks</button>
                </span>
                <span class="popOverStatus ml-2" v-else>
                  <span v-if="trackingData.length-1 == index">
                    <span :class="dottedStatus('Pending')"></span>
                    <span class="ml-2">Pending</span>
                  </span>
                  <span v-else>-</span>
                </span>
              </div>
              <div v-if="roleName.length != 4" class="col-2 m-0 p-0 pl-3">
                <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[4]}}</h4>
                <span v-if="data.commercial != null">
                  <span :class="dottedStatus(data.commercial.evaluatorsActionStatus)"></span>
                  <span class="popOverStatus ml-2">{{data.commercial.evaluatorsActionStatus}}</span>
                  <br />
                  <span class="popOverStatusActionBy">{{data.commercial.actionBy}}</span>
                  <br />
                  <span class="popOverDate">{{getCreatedDate(data.commercial.insertedOn)}}</span>
                  <br />
                  <button
                    class="popOverRemarks"
                    v-b-popover.hover.bottomright="data.commercial.remarks"
                  >Remarks</button>
                </span>
                <span class="popOverStatus ml-2" v-else>
                  <span v-if="trackingData.length-1 == index">
                    <span :class="dottedStatus('Pending')"></span>
                    <span class="ml-2">Pending</span>
                  </span>
                  <span v-else>-</span>
                </span>
              </div>
              <div v-if="roleName.length != 4" class="col-2 m-0 p-0 pl-3">
                <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[5]}}</h4>
                <span v-if="data.approver != null">
                  <span :class="dottedStatus(data.approver.evaluatorsActionStatus)"></span>
                  <span class="popOverStatus ml-2">{{data.approver.evaluatorsActionStatus}}</span>
                  <br />
                  <span class="popOverStatusActionBy">{{data.approver.actionBy}}</span>
                  <br />
                  <span class="popOverDate">{{getCreatedDate(data.approver.insertedOn)}}</span>
                  <br />
                  <button
                    class="popOverRemarks"
                    v-b-popover.hover.bottomright="data.approver.remarks"
                  >Remarks</button>
                </span>
                <span class="popOverStatus ml-2" v-else>
                  <span v-if="trackingData.length-1 == index">
                    <p :class="dottedStatus('Pending')"></p>
                    <span class="ml-2">Pending</span>
                  </span>
                  <span v-else>-</span>
                </span>
              </div>
            </div-->
          </b-modal>
    <c-summary-navbar :userName="eipUserName" :protalName="'Grievance Dashboard'" @userLogout="logout()" />
   
  <div class="wb-head" style="padding-right: 30px;"> Grievance List 
  <button @click="downloadFile()" style="font-weight:normal;
  font-size:16px;float:right;cursor:pointer;height: 30px;max-height: 30px;
    line-height: 15px;margin-top: 5px;" class="btn btn-success">Report 
    <span style="font-size:20px;font-weight:bold;"> &#10515;</span>
  </button></div> 
    <div style="padding:5px 20px 20px 20px;">
      <span v-if="loading">Loading data...</span>
    <vue-good-table
      :columns="columns"
      :rows="rows"
      max-height="400px"
  :fixed-header="true"
  :search-options="{
    enabled: true
  }"
  :pagination-options="{
    enabled: true
  }"/>
    </div>
          <widgetModal
      :trigger="triggerModal"
      :text="lastResponse"
      :title="modalTitle"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      :showAlert="failureModal"
      :showSuccess="successModal"
      @eventClose="changeModalStatus()"
    />
    </div>
</template>

<script>
import quicklinkWorkflow from "../components/summary/quicklinkWorkflow";
import testimonialsWorkflow from "../components/summary/testimonialsWorkflow";
import partnerEvaluation from "../components/partnerfeedback/partnerEvaluation";
import gstWorkflow from "../components/summary/gstApproval";
import businessCategoryWorkflow from "../components/summary/businessCategoryApproval";
import SummaryNavbar from "../components/summary/summaryNavbar";
import TextArea from "../widgets/TextArea";
import LoadingSpinner from "../widgets/LoadingSpinner";
import widgetModal from "../widgets/newModalWidget";
import moment from "moment";
import { SummaryServices } from "../services/summaryService";
const summaryService = new SummaryServices();
import multiSelect from "vue-multi-select";
import Datepicker from "vuejs-datepicker";
import { VueGoodTable } from 'vue-good-table';

import { AESService } from "../services/AES.js";
let aesService = new AESService();
import 'vue-good-table/dist/vue-good-table.css'
export default {
  components: {
    "c-gst": gstWorkflow,
    "c-quicklink": quicklinkWorkflow,
    "c-testimonials": testimonialsWorkflow,
    "c-business-category": businessCategoryWorkflow,
    "c-summary-navbar": SummaryNavbar,
    "c-feedback": partnerEvaluation,
    "w-text-area": TextArea,
    "w-loading-spinner": LoadingSpinner,
    multiSelect,
    Datepicker,
    VueGoodTable,
    widgetModal
  },
  data() {
    return {
      loading: false,
      companyCodeToPass:'',
      originalArray:[],
      frRolesList:[],
      traceData: [],
      docSearch: "",
      answerNumber: "",
      userId: "",
      userCode: "",
      eipUserName: "",
      auditNo: "",
      companyCode: "",
      orderTypeCode: "",
      OverAllSubmitApprover: false,
      openTrackingModal: false,
      openWorkflowHistoryModal: false,
      partnerLoadig: false,
      overAllremarks: "",
      enableSubmit: true,
      actionStatus: "",
      failureModal: false,
      triggerModal: false,
      successModal: false,
      alertModal: false,
      lastResponse: "",
      gstWorkflow: false,
      quicklinkWorkflow: false,
      testimonialsWorkflow: false,
      feedbackWorkFlow: false,
      moduleWorkflow: "",
      trackingDetails: "",
      roleName: [],
      effectiveFromDate: "",
      effectiveToDate: "",
      businessCatWorkflow: false,
      showContigentPopUp: false,
      radioInputValue: [],
      contigentValue: "",
      selectedJobValue: [],
      position: "bottom",
      selectedJob: values => `Selected Job (${values.length})`,
      state: {
        disabledDates: {
          from: "",
          to: ""
        }
      },
      contigentEndDate: "",
      overallRemarkspopUp: "",
      madatoryFileds: false,
      columns: [
        {
          label: 'Document Number',
          field: 'requestNumber',
          type: 'String'
        },
        {
          label: 'Created by',
          field: 'partnerName',
          type: 'String'
        },        
        {
          label: 'Job Code',
          field: 'jobCode',
          type: 'String'
        },
        {
          label: 'Order Numbers',
          field: 'orderNumber',
          type: 'String'
        },
        {
          label: 'Grievance Description',
          field: 'grievanceDescription',
          type: 'String'
        },
        {
          label: 'Status',
          field: 'status',
          type: 'String'
        },
        {
          label: 'Created On',
          field: 'createdOn',
          type: 'String'
        },
        {
          label: 'Actions',
          field: 'actions',
          html: true
        },
      ],
      rows: [],
      currentDocuNumberForAction:'',      
      encryptsecret: atob(process.env.VUE_APP_S_S),
    };
  },
  created() {
    var self = this
    this.decryptfunction();
    $(document).on('click', '[id^="trace"]', function(e){
      //if(this.currentDocuNumberForAction != e.target.id.split('~~~')[1]) {
        e.preventDefault();
      e.stopPropagation();
      var doc = e.target.id.split('~~~')[1]
      if(doc.indexOf('PCR') > -1){
        self.getWorkFlowHistoryPCR(e.target.id.split('~~~')[1])
      } else {
        self.openTrackingStatus(e.target.id.split('~~~')[1])
      }
      //}
    })
    $(document).on('click', '[id^="authorize"]', function(e){
      //if(this.currentDocuNumberForAction != e.target.id.split('~~~')[1]) {
        e.preventDefault();
        e.stopPropagation();
      self.goToApprovalPage(e.target.id.split('~~~')[1])
      //}
    })
  },
  computed: {},
  methods: {
    downloadFile(){
     var data={
        companyCode:null,
        icCode: null,
        statusCode: null,
        reasonTypeCode: null,
        startDate: null,
        endDate: null
      }
     // window.alert(JSON.stringify(data))
      summaryService.downloadGrievanceList(data)
        .then(res => {
        })
        .catch(err => {
          this.loading = false;
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = err.failureMessage;
              this.alertModal = true;
        });
    },
    goToVendorMaster(){
      let routeData = this.$router.resolve({name: 'ForensicsDashboard'}); //, query: {data: ""}
       window.open(routeData.href, '_blank');
    },
    getRoleName(frCode) {
      if (frCode == 0)
      {
        return 'Partner'
      }
      return this.frRolesList.filter(x=>x.frCode == frCode).length > 0 ? 
      (this.frRolesList.filter(x=>x.frCode == frCode)[0]).longDesc : 'Not available'
    },
    
    getWorkFlowHistoryPCR(doc){
      var self = this
      summaryService.getWorkFlowHistory(doc)
        .then(res => {
          this.loading = false;
            if (res.status == "SUCCESS") {
          this.historyList = res.response.workflows;          
          this.openWorkflowHistoryModal = true;
            } else {
              this.triggerModal = true;
              this.loading = false;
              this.failureModal = false;              
              this.lastResponse = res.failureMessage; 
              this.alertModal = true;
            }})
        .catch(err => {
          this.loading = false;
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = err.failureMessage ? err.failureMessage : "Something went wrong. Try again later.";
              this.alertModal = true;
        });
    },
    getWorkFlowHistory(){
      var self = this
      summaryService.getWorkFlowHistory(this.docSearch)
        .then(res => {
          this.loading = false;
            if (res.status == "SUCCESS") {
          this.historyList = res.response.workflows;          
          this.openWorkflowHistoryModal = true;
            } else {
              this.triggerModal = true;
              this.loading = false;
              this.failureModal = false;              
              this.lastResponse = res.failureMessage; 
              this.alertModal = true;
            }})
        .catch(err => {
          this.loading = false;
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = err.failureMessage ? err.failureMessage : "Something went wrong. Try again later.";
              this.alertModal = true;
        });
    },
    EncodeUsingAES(value) {
      var CryptoJS = require("crypto-js");
      if (value === undefined || value === null) {
        return "";
      } else {
        const keys = atob(process.env.VUE_APP_E_4)
        const key = CryptoJS.enc.Utf8.parse(keys);
        const vectorIV = CryptoJS.enc.Utf8.parse(keys);
        const encrypted = CryptoJS.AES.encrypt(
          CryptoJS.enc.Utf8.parse(value.toString()),
          key,
          {
            keySize: 128 / 8,
            iv: vectorIV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          }
        );
        return encrypted.toString();
      }
    },
    encrypt(text, i) {
      var CryptoJS = require("crypto-js");
      var encrypted = {};
      var ciphertext = CryptoJS.AES.encrypt(
        JSON.stringify(text),
        this.encryptsecret
      );
      encrypted = {
        key: ciphertext.key + "", // don't send this
        iv: ciphertext.iv + "", // don't send this
        salt: ciphertext.salt + "", // don't send this
        ciphertext: ciphertext.ciphertext + "", // don't send this
        str: ciphertext + "" // send or store this
      };
      sessionStorage.setItem("summaryToken", encrypted.str);
      this.$router.push({ name: this.url });
    },
    formatDateTime(dt, splitter){ 
      console.log(dt)
      var dateArray = (dt.split(splitter)[0]).split('-')
      var timeArray = (dt.split(splitter)[1]).split(':')
      var date = dateArray[2]
      var month = dateArray[1]
      var year = dateArray[0] 
      var h = timeArray[0]
      var m = timeArray[1]
      
      var ampm = (h >= 12) ? "PM" : "AM"
      h = ((h > 12) ? h-12 : h)
      h = (h.toString()).length == 1 ? ('0'+h) : h
      return (date + '-' + month + '-' + year) + ' ' + h + ":" + m + " " + ampm;
    },
    getStatusText(statusCode){
      if (statusCode == 1) {
      return 'Approved';
      } else if (statusCode == 2) {
      return 'SendBack';
      } else if (statusCode == 3) {
      return 'Rejected';
      } else if (statusCode == 4) {
      return 'Requested';
      } else if (statusCode == 5) {
      return 'PartialApproved';
      } else if (statusCode == 6) {
      return 'AutoCancel';
      } else if (statusCode == 7) {
      return 'Created';
      } else if (statusCode == 8) {
      return 'Resolved';
      } else if (statusCode == 9) {
      return 'Closed';
      } else if (statusCode == 10) {
      return 'Forwarded';
      } else if (statusCode == 11) {
      return 'Reopened';
      } else if (statusCode == 13) {
      return 'Reviewed';
      }
    },
    decryptfunction() {
      var self = this
      var CryptoJS = require("crypto-js");
      var token = sessionStorage.getItem("summaryToken");
      self.companyCodeToPass = sessionStorage.getItem("companyCode");
      var bytes = token && CryptoJS.AES.decrypt(token.toString(), atob(process.env.VUE_APP_S_S));
      var decryptedData = bytes && JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      if (decryptedData) {
      this.answerNumber = decryptedData.decodedRequestNumber;
      this.userId = decryptedData.eipUsersUserid;
      this.userCode = decryptedData.evaluatorsFRCode;
      this.eipUserName = decryptedData.eipUserName;
      this.auditNo = decryptedData.auditNumber;  
      }
      
      this.loading = true;
      summaryService.getGrievanceList(self.companyCodeToPass, decryptedData.eipActualUserId)
        .then(res => {
          this.loading = false;  
            if (res.status == "SUCCESS") {
          this.rows = res.response;
          this.rows.map(x => x.status = self.getStatusText(x.status))
          this.rows.map(x => x.createdOn = self.formatDateTime(x.createdOn, 'T'))          
          this.rows.map(x => x.actions = 
          `<!--button class="btn btn-primary custom-btn" id="authorize~~~${x.requestNumber}">View</button-->
           <button class="btn btn-primary custom-btn" id="trace~~~${x.requestNumber}">Trace</button>`)
            } else {
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = res.failureMessage; 
              this.alertModal = true;
            }})
        .catch(err => {
          this.loading = false;
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = err.failureMessage;
              this.alertModal = true;
        });
      this.getAllInfo();
    },
    goToApprovalPage(answerNumber){
      this.currentDocuNumberForAction = answerNumber
      var data = {
        eipUserId: sessionStorage.getItem("eipUserId"),
        encodedRequestNumber: this.EncodeUsingAES(answerNumber),
        eipSessionId: sessionStorage.getItem("eipSessionId"),
        latitude: null,
        location: null,
        loginFrom: "Onboard WorkFlow",
        longitude: null,
        companyCode: this.companyCode,
        source:  sessionStorage.getItem("source")
      };
      
      var sessionData = {
        userid: sessionStorage.getItem("eipUserId"),
        usercode: this.EncodeUsingAES(answerNumber)
      };
      summaryService.intermediatePage(data)
        .then(resp => {
          if (resp.response.userDetails) {
            if (resp.response.userDetails.menuUrl == "FeedbackApproval") {
              this.url = "PartnerApproval"; 
            } else {
              this.url = resp.response.userDetails.menuUrl;
            }
            this.isLoading = false;
            this.encrypt(resp.response.userDetails);
            
            sessionStorage.setItem(
              "sessiontimeout",
              JSON.stringify(sessionData)
            );
            this.$router.push({ name: this.url });
          } else {
            this.isLoading = false;
            if (resp.failureMessage) {
              alert(resp.failureMessage); 
              //location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
            }
          } 
        })
        .catch(err => {
          this.isLoading = false;
          console.log(err)
          var errorMsg = (err && err.failureMessage) ? err.failureMessage : "Something went wrong. Try again later.";
          alert(errorMsg);
          //location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
        });
    },
    openTrackingStatus(answerNumber) {
      this.currentDocuNumberForAction = answerNumber
      this.loading = true;
      summaryService.getWorkFlowHistory(answerNumber)
        .then(res => {
          this.loading = false;
            if (res.status == "SUCCESS") {
              this.originalArray = res.response.workflows
              this.frRolesList = res.response.frRolesList
          this.traceData=[]
          var n=[]
          //n.push(this.originalArray[0])
          for (var i = 0; i < this.originalArray.length; i++) {
            if (this.originalArray[i].actionStatus == 6) { 
              continue;
            } 
            if (this.originalArray.length-1 == i) {
              n.push(this.originalArray[i])
              this.traceData.push(n)
              n=[] 
            }
            else if (this.originalArray[i].actionStatus != 2) { 
              n.push(this.originalArray[i])
            } else if (this.originalArray[i].actionStatus == 2){
              n.push(this.originalArray[i])
              this.traceData.push(n)
              n=[]
            }
          }
          var lastArray = this.traceData[this.traceData.length-1];
          var allfour = lastArray.filter(x=>x.actionStatus==4)
          if(allfour.length == lastArray.length){
            for (var j=0; j<lastArray.length; j++){
              lastArray[j]["isShow"] = true;
            }
          }
          this.traceData[this.traceData.length-1] = lastArray
          //this.traceData[0][0]["frCode"] = 0
          console.log(this.traceData)
            } else {
              this.triggerModal = true;
              this.loading = false; 
              this.failureModal = false;              
              this.lastResponse = res.failureMessage; 
              this.alertModal = true;
            }
            this.openTrackingModal = true;
            })
        .catch(err => {
          this.loading = false;
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = err.failureMessage ? err.failureMessage : "Something went wrong. Try again later.";
              this.alertModal = true;
        });
      /*summaryService.getTrackingData(answerNumber)
        .then(res => {
          this.loading = false;
          this.trackingData = res.response.status;
          this.roleName = res.response.evaluatorsName;
      this.openTrackingModal = true;
        })
        .catch(err => {
          this.loading = false;
        });*/
    },
    closeTrackingModal() {
      this.openTrackingModal = false;
    },
    getCreatedDate(date) {
      return moment(date).format("DD-MMM-YYYY hh:mm A");
    },
    getAllInfo() {
      if (this.userCode == 103) {
        //this.loading = false;
        this.userName = "buyer";
        this.protalName = "Buyer";
      } else if (this.userCode == 104) {
        //this.loading = false;
        this.userName = "technical";
        this.protalName = "Technical";
      } else if (this.userCode == 105) {
        //this.loading = false;
        this.userName = "commercial";
        this.protalName = "Commercial";
      } else if (this.userCode == 106) {
        //this.loading = false;
        this.userName = "approver";
        this.protalName = "Approver";
      } else if (this.userCode == 107) {
        //this.loading = false;
        this.userName = "projecthead";
        this.protalName = "Project Head";
      } else if (this.userCode == 108) {
        //this.loading = false;
        this.userName = "icscmhead";
        this.protalName = "ICSCM Head";
      } else if (this.userCode == 109) {
        //this.loading = false;
        this.userName = "buhead";
        this.protalName = "BU Head";
      }
    },
    documentApprover(value) {
      if (this.moduleWorkflow == "PTM") {
        if (this.effectiveToDate == "" || this.effectiveFromDate == "") {
          this.triggerModal = true;
          this.alertModal = true;
          this.lastResponse = "Please fill the Testimonial duration";
        } else {
          this.actionStatus = value;
          this.overAllremarks = "";
          this.enableSubmit = true;
          this.OverAllSubmitApprover = true;
        }
      } else if (this.moduleWorkflow == "PBC") {
        if (this.userName == "buyer") {
          this.actionStatus = value;
          this.getContigentRadioValue();
          this.getContigentJob();
        } else {
          this.overallRemarkspopUp = "";
          this.enableSubmit = true;
          this.OverAllSubmitApprover = true;
        }
      } else {
        this.actionStatus = value;
        this.overAllremarks = "";
        this.enableSubmit = true;
        this.OverAllSubmitApprover = true;
      }
    },
    sendBack(value) {
      this.actionStatus = value;
      this.overAllremarks = "";
      this.enableSubmit = true;
      this.OverAllSubmitApprover = true;
    },
    rejectReview(value) {
      this.actionStatus = value;
      this.overAllremarks = "";
      this.enableSubmit = true;
      this.OverAllSubmitApprover = true;
    },
    getOverallRemarks(event) {
      if (event.length > 2) {
        this.enableSubmit = false;
      } else {
        this.enableSubmit = true;
      }
      this.overAllremarks = event;
      if (this.moduleWorkflow == "PBC") {
        this.overallRemarkspopUp = event;
      }
    },    
    dottedStatus(status) {
      if (status == "Approved") {
        return "dottedGreen";
      }
      if (status == "Sendback") {
        return "dottedSendback";
      }
      if (status == "Rejected") {
        return "dottedRejected";
      }
      if (status == "Pending") {
        return "dottedPending";
      }
    },
    getUserInputValue(event) {
      this.companyCode = event.companyCode;
      this.orderTypeCode = event.orderType;
    },
    overAllSumbit() {
      if (this.moduleWorkflow == "PTM") {
        var testimonialsApproveData = {
          actionStatus: this.actionStatus,
          effectiveFromDate: this.effectiveFromDate,
          effectiveToDate: this.effectiveToDate,
          requestNumber: this.answerNumber,
          userId: this.userId
        };
        this.loading = true;
        summaryService
          .testimonialsApproval(testimonialsApproveData)
          .then(res => {
            if (res.status == "SUCCESS") {
              this.triggerModal = true;
              this.loading = false;
              this.successModal = true;
              this.lastResponse = "Document Approved Sucessfully";
              sessionStorage.clear();
            } else {
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = res.failureMessage;
              this.alertModal = true;
            }
          })
          .catch(error => {
            this.triggerModal = true;
            this.loading = false;
            this.lastResponse = error.failureMessage;
            this.alertModal = true;
          });
      } else if (this.moduleWorkflow == "PBC") {
        this.OverAllSubmitApprover = false;
        this.showContigentPopUp = false;
        let reviewObject = {};
        reviewObject.actionStatus = this.actionStatus;
        reviewObject.requestNumber = this.answerNumber;
        reviewObject.userId = this.userId;
        reviewObject.remarks = this.overallRemarkspopUp;
        reviewObject.auditNumber = this.auditNo;
        reviewObject.segregatorToBuyers = [];
        reviewObject.classificationCode = this.contigentValue;
        reviewObject.jobCode =
          this.selectedJobValue.length == 0
            ? null
            : this.selectedJobValue[0].value;
        reviewObject.exceptedEndDate = this.contigentEndDate;
        reviewObject.orginType =
          this.selectedJobValue.length == 0
            ? null
            : this.selectedJobValue[0].orgin;
        this.loading = true;
        // console.log(reviewObject)
        if (reviewObject) {
          console.log(reviewObject);
          summaryService
            .buyerActionBusinessCategories(reviewObject)
            .then(res => {
              if (res.status == "SUCCESS") {
                this.triggerModal = true;
                this.loading = false;
                this.successModal = true;
                if (this.actionStatus == "3") {
                  this.lastResponse =
                    "Business Categories Rejected Sucessfully";
                } else if (this.actionStatus == "1") {
                  this.lastResponse =
                    "Business Categories Approved Sucessfully";
                }
                sessionStorage.clear();
              } else {
                this.triggerModal = true;
                this.loading = false;
                this.lastResponse = res.failureMessage;
                this.alertModal = true;
              }
            })
            .catch(error => {
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = error.failureMessage;
              this.alertModal = true;
            });
        }
      } else {
        if (this.moduleWorkflow == "feedback") {
          var formdata = {
            actionStatus: this.actionStatus,
            auditNumber: this.auditNo,
            remarks: this.overAllremarks,
            documentNumber: this.answerNumber,
            companyCode: this.companyCode,
            orderTypeCode: this.orderTypeCode,
            userId: this.userId
          };
        } else {
          var formdata = {
            actionStatus: this.actionStatus,
            auditNumber: this.auditNo,
            remarks: this.overAllremarks,
            requestNumber: this.answerNumber,
            segregatorToBuyers: [],
            userId: this.userId
          };
        }

        this.loading = true;
        summaryService
          .summaryAction(formdata, this.moduleWorkflow, this.userName)
          .then(resp => {
            if (resp.status == "SUCCESS") {
              this.triggerModal = true;
              this.loading = false;
              this.successModal = true;
              this.lastResponse = resp.response;
              sessionStorage.clear();
            } else {
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = resp.failureMessage;
              this.alertModal = true;
            }
          })
          .catch(error => {
            this.triggerModal = true;
            this.loading = false;
            this.lastResponse = error.failureMessage;
            this.alertModal = true;
          });
      }
    },
    partnerApproval() {
      this.loading = true;
      summaryService
        .summaryAction()
        .then(resp => {
          if (resp.status == "SUCCESS") {
            this.loading = false;
            this.successModal = true;
            this.lastResponse = resp.response;
            sessionStorage.clear();
          } else {
            this.loading = false;
            this.lastResponse = resp.failureMessage;
            this.alertModal = true;
          }
        })
        .catch(error => {
          this.loading = false;
          this.lastResponse = error.failureMessage;
          this.alertModal = true;
        });
    },
    changeModalStatus() {
      this.triggerModal = false;
      this.successModal = false;
      this.enterAllDetails = false;
      this.ratingsEmpty = false;
      this.failureModal = false;
    },
    changeModalSuccess() {
      sessionStorage.removeItem("token");
      location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
    },
    closeModal() {
      if (this.lastResponse == "Please fill the Testimonial duration") {
        this.triggerModal = false;
        this.alertModal = false; 
        this.lastResponse = "";
      } else {
        sessionStorage.removeItem("token");
        location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
      }
    },
    logout() {
      let data = {};
      var logouttime = new Date();
      data.lastActionTime = null;
      data.loginAuditNumber = aesService.EncodeUsingAES(this.auditNo);
      data.logoutTime = logouttime;
      data.logoutType = "U";
      summaryService.userLogout(data)
        .then(res => {
          sessionStorage.clear();
          location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
        })
        .catch(err => {
          location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
        });
    },
    getTestimonialDuration(event) {
      console.log(event);
      this.effectiveFromDate = event.effectiveFrom;
      this.effectiveToDate = event.effectiveUpto;
      console.log(this.effectiveFromDate);
      console.log(this.effectiveToDate);
    },
    closeSecondaryModal() {
      this.showContigentPopUp = false;
    },
    getJobdate(event) {
      this.contigentEndDate = event;
    },
    checkMandatoryFields() {
      if (this.contigentValue == 1) {
        if (this.overallRemarkspopUp == "") {
          this.madatoryFileds = true;
          return true;
        } else {
          this.madatoryFileds = false;
          return false;
        }
      }
      if (this.contigentValue == 2) {
        if (
          this.selectedJobValue.length == 0 ||
          this.contigentEndDate == "" ||
          this.overallRemarkspopUp == ""
        ) {
          this.madatoryFileds = true;
          return true;
        } else {
          this.madatoryFileds = false;
          return false;
        }
      }
    },
    getContigentRadioValue() {
      this.loading = true;
      summaryService
        .getContigentRadioInputValue(this.answerNumber)
        .then(resp => {
          if (resp.response) {
            console.log(resp);
            this.loading = false;
            this.showContigentPopUp = true;
            this.radioInputValue = resp.response;
            if (this.radioInputValue.length == 1) {
              this.contigentValue = this.radioInputValue[0].classificationCode;
            }
            // this.contigentValue = 2;
          } else {
            this.loading = false;
            this.triggerModal = true;
            this.lastResponse = resp.failureMessage;
            this.alertModal = true;
          }
          // this.radioInputValue.push({});
        });
    }
  }
};
</script>

<style scoped>
</style>
<style>
.model-content {
  width: 100% !important;
}
.modal-header {
  font-family: "Source Sans Pro", sans-serif;
  padding: 2% !important;
  color: white;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.modal-footer > .btn-primary {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  text-align: center;
  color: white !important;
  /* border-radius: 2px; */
  background-color: #1579ab;
}
.summaryNavbar {
  background-color: #14436a;
}
.approverButton {
  font-size: 16px;
  font-weight: 600;
  color: white;
  cursor: pointer;
  font-family: "Source Sans Pro", sans-serif;
  outline: none !important;
  padding: 3%;
  float: left;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.approverstatus {
  font-size: 16px;
  font-weight: 600;
  color: white;
  cursor: pointer;
  font-family: "Source Sans Pro", sans-serif;
  outline: none !important;
  padding: 3%;
  float: left;
  margin-left: 40%;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.role-Name {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px;
  font-weight: bold;
  text-decoration: underline;
  margin-bottom: 10% !important;
}
.dottedPending {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #f4cf08;
  float: left;
  margin-top: 2%;
}
.dottedGreen {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #28b915;
  float: left;
  margin-top: 3%;
}
.popOverRemarks {
  cursor: pointer;
  float: left;
  font-size: 12px;
  color: #747474;
  text-decoration: underline;
  outline: none !important;
}
.popOverDate {
  float: left;
  font-size: 12px;
  color: #747474;
}
.vgt-table th{  
  padding: 5px 10px !important;
    font-size: 14px !important;
    background-color: #1a72ab !important;
    background: #1a72ab !important;
    color:#fff !important;
}
table.vgt-table td{
  padding: 5px 10px !important;
    font-size: 14px !important;
}
table.vgt-table tr:nth-child(even) {background-color: #f2f2f2;}
.footer__row-count__select{
  width: 30px !important;
  padding: 5px !important;
}
.custom-btn{padding:0px 10px; 
          background-color:#09599a;}
#vendor-details, #workflow-history{
     max-width: 250px;
    display: inline-block;
}
.query-pane button{
    background-color: #09599a;
    margin-left:10px;
    height: 32px;
    margin-top: -4px;
}
.wb-head{
  text-align: left;
    padding-left: 25px;
    font-size: 20px;
    font-weight: bold;
}
.modal-fullscreen{
  max-width: 100%;
}
.modal-fullscreen .modal-dialog{
  width:100% !important;
  max-width: 100% !important;
}

.modal-fullscreen .modal-dialog .modal-content{
  width:95% !important;
}
.wf-history-table{
  width: 100%;
}
.wf-history-table td{
  padding:10px;
}
.text-green{
  color:green;
  font-weight: bold;
}
.text-red{
  color:red;
  font-weight: bold;
}
.text-yellow{
  color:#dec300;
  font-weight: bold;
}
.text-orange{
  color:orange;
  font-weight: bold;
}
.bold{
  font-weight: bold;
}
.trace-wrap{
  height: 20px;
    overflow: hidden;
    white-space: nowrap;
    max-width: 200px;
    text-overflow: ellipsis;
}
.trace-wrap div{
  overflow: hidden;
    text-overflow: ellipsis;
}

.linker{
    float: right;
    padding-right: 22px;
    font-weight: bold;
    color: #005aff;
    font-size: 18px;
    text-decoration: underline;
    cursor: pointer;
}
.vgt-table th, .vgt-table td{max-width: 400px !important;overflow: auto;word-break: break-all;}
.vgt-fixed-header{display: none !important;}
</style>
